import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbCalendar, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { Globals } from "../../../common/globals";

import { TimeService } from "@services/generic/time.service";

export interface TimeItem {
  hour: number;
  minute: number;
}
export interface ScheduleItem {
  weekDays: Array<number>;
  fromDate: NgbDate;
  toDate: NgbDate;
  timeFrom: TimeItem;
  timeTo: TimeItem;
}
@Component({
  selector: "app-datepicker",
  templateUrl: "./datepicker.component.html",
  styleUrls: ["./datepicker.component.scss"],
})
export class DatepickerComponent implements OnInit {
  @Input() editScheduleIsLoaded = false;

  public startTime: string;
  public endTime: string;
  public hoveredDate: NgbDate;
  public timeError: boolean = false;

  @Input() fromDate: NgbDate;
  @Input() toDate: NgbDate;
  @Input() timeFrom: TimeItem = { hour: 10, minute: 30 };
  @Input() timeTo: TimeItem = { hour: 15, minute: 30 };
  @Input() weekDays: Array<number> = [1, 2, 3, 4, 5, 6, 7];
  @Input() weekDayString = Globals.weekDayString;

  @Output() onDoneSchedule: EventEmitter<ScheduleItem> = new EventEmitter();

  constructor(private calendar: NgbCalendar, private timeSvc: TimeService) {
    this.fromDate = calendar.getToday();
  }

  ngOnInit(): void {}

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      date.equals(this.toDate) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  selectDay(i) {
    if (this.weekDays.length < 2 && this.weekDayString[i].clicked == true) {
      return;
    }
    let selectedDay = i + 1;
    this.weekDayString[i].clicked = !this.weekDayString[i].clicked;
    if (this.weekDays.includes(selectedDay)) {
      let index = this.weekDays.indexOf(selectedDay);
      if (index > -1) {
        this.weekDays.splice(index, 1);
      }
    } else {
      this.weekDays.push(selectedDay);
    }
  }

  onClickDoneSchedule() {
    if (!this.toDate) {
      this.toDate = this.fromDate;
    }

    if (this.validateTime() === false) {
      return false;
    }

    this.onDoneSchedule.emit({
      weekDays: this.weekDays,
      fromDate: this.fromDate,
      toDate: this.toDate,
      timeFrom: this.timeFrom,
      timeTo: this.timeTo,
    });

    this.editScheduleIsLoaded = false;
    this.timeError = false;
  }

  validateTime() {
    if (this.timeFrom == null || this.timeTo == null) {
      this.timeError = true;
      return false;
    }
    if (this.timeFrom.hour > this.timeTo.hour) {
      this.timeError = true;
      return false;
    }
    if (this.timeFrom.hour === this.timeTo.hour) {
      if (this.timeFrom.minute > this.timeTo.minute) {
        this.timeError = true;
        return false;
      }
    }

    return true;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate) {
      if (date.before(this.fromDate)) {
        this.fromDate = date;
      } else {
        this.toDate = date;
      }
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  resetPicker() {
    this.startTime = "";
    this.endTime = "";

    this.weekDays = [1, 2, 3, 4, 5, 6, 7];
    this.fromDate = this.calendar.getToday();
    this.toDate = null;
    this.timeFrom = { hour: 1, minute: 30 };
    this.timeTo = { hour: 15, minute: 30 };
    this.timeError = false;
    this.weekDayString.forEach((a) => {
      a.clicked = true;
    });
  }
}
